import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSameLtr = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "16px",
	height: "16px",
	viewBox: "-7 9 16 16",
	enableBackground: "new -7 9 16 16",
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "same" }), /* @__PURE__ */ _jsx("g", {
		id: "Non_mover",
		children: /* @__PURE__ */ _jsx("polygon", { points: "7,17 0,9 -5,9 -5,25 0,25  " })
	})]
});
export default SvgSameLtr;
